
import { Language } from './types';

export const translations = {
  en: {
    welcome: "Welcome back,",
    hello: "Hello!",
    streakTitle: "Consistency Streak",
    streakSubtitle: "(3+ meals/day in last 10 days)",
    day: "Day",
    recordMeal: "Record Meal",
    recordSymptom: "Side Effects",
    swipeHint: "Swipe left to view journals",
    mealJournal: "Meal Journal",
    symptomJournal: "Side Effects Journal",
    itemsLogged: "Items Logged Today",
    noMeals: "No meals logged yet.",
    noSymptoms: "No side effects logged yet.",
    listeningItems: "Listening for items...",
    listeningSymptoms: "Describing physical state...",
    itemsLoggedCount: "items logged",
    symptomsLoggedCount: "symptoms logged",
    time: "Time",
    item: "Item",
    qty: "Qty",
    symptom: "Symptom",
    intensity: "Intensity",
    molecularComp: "Molecular Composition",
    analyzing: "Analyzing chemical structure...",
    noData: "No chemical data available.",
    recordingMeal: "Recording Meal",
    recordingSymptoms: "Recording Symptoms",
    offline: "Offline",
    home: "Home",
    meal: "Meal",
    meals: "Meals",
    symptoms: "Symptoms",
    stats: "Stats",
    settings: "Settings",
    preferences: "Preferences",
    language: "Language",
    darkMode: "Dark Mode",
    notifications: "Notifications",
    enableNotifications: "Enable Notifications",
    reminders: "Daily Reminders",
    account: "Account",
    dataManagement: "Data Management",
    exportData: "Export Data (JSON)",
    importData: "Import Data (JSON)",
    importSuccess: "Data imported successfully!",
    importError: "Failed to import data. Check file format.",
    sendFeedback: "Send Feedback",
    shareApp: "Share App",
    logout: "Log Out",
    login: "Log In",
    signup: "Sign Up",
    email: "Email",
    password: "Password",
    breakfast: "Breakfast",
    lunch: "Lunch",
    dinner: "Dinner",
    snack: "Snack",
    afternoonSnack: "Afternoon Snack",
    addMealTooltip: "Record new meal",
    addSymptomTooltip: "Record symptom",
    deleteItem: "Delete item",
    deleteItemConfirm: "Are you sure you want to delete this record?",
    deleteSymptom: "Delete symptom",
    addItemToMeal: "Add items",
    deleteSessionConfirm: "Are you sure you want to delete this entire entry? This action cannot be undone.",
    deleteSessionTooltip: "Delete entire entry",
    noAccount: "Don't have an account?",
    haveAccount: "Already have an account?",
    verifyEmail: "Verify Email",
    enterCode: "Enter Verification Code",
    codeSentTo: "We sent a 4-digit code to",
    verify: "Verify",
    resendCode: "Resend Code",
    invalidCode: "Invalid code. Try '1234'.",
    codeSentAlert: "Your verification code is: 1234",
    today: "Today",
    yesterday: "Yesterday",
    aiInsights: "AI Health Insights",
    aiInsightsPreliminary: "Preliminary Analysis",
    aiInsightsLocked: "Analysis Locked",
    learningPhase: "Learning Phase",
    dataPoints: "Data Points",
    daysTracked: "Days Tracked",
    analysisComplete: "Analysis Ready",
    highRisk: "High Probability",
    mediumRisk: "Medium Probability",
    lowRisk: "Low Probability",
    potentialIrritant: "Potential Irritant",
    generateAnalysis: "Update Analysis",
    startAnalysis: "Reveal Correllations",
    locked: "Locked",
    readyToAnalyze: "We have enough data to identify potential triggers.",
    readyToAnalyzeLowData: "Preliminary check available.",
    analyzingPatterns: "Detecting molecular patterns...",
    notEnoughData: "Continue logging meals and symptoms to unlock AI insights.",
    notEnoughDataLowData: "Historical data low (<14 days). AI can run a rough check, but accuracy will be lower.",
    lockedMessage: "Log at least 10 unique days of history to unlock AI analysis.",
    unlockProgress: "{{current}} / 10 Days of History",
    recordedSuccessfully: "Recorded Successfully!",
    editSession: "Edit Time",
    update: "Update",
    cancel: "Cancel",
    selectTime: "Select Date & Time",
    changeSeverity: "Adjust Severity",
    editQuantity: "Edit Quantity",
    save: "Save",
    customUnit: "Custom Unit",
    quickSelect: "Quick Select Unit",
    manualEntry: "Manual Entry",
    enterFoodName: "Enter food name (e.g. Apple)",
    enterSymptomName: "Enter symptom (e.g. Headache)",
    addManually: "Add Manually",
    processing: "Processing...",
    changeMealType: "Change Meal Type",
    chooseInputMethod: "Choose Input Method",
    inputAudio: "Voice Record",
    inputText: "Manual Text",
    inputBarcode: "Scan Barcode",
    inputCamera: "Take Picture",
    comingSoon: "Coming Soon",
    scale0: "No symptoms at all",
    scale1_2: "Very mild — barely noticeable",
    scale3_4: "Mild — noticeable but doesn’t interfere",
    scale5_6: "Moderate — interferes somewhat with activities",
    scale7_8: "Severe — greatly limits activity/comfort",
    scale9: "Very severe — nearly incapacitating",
    scale10: "Extreme — unbearable or disabling",
    u_piece: "piece",
    u_slice: "slice",
    u_serving: "serving",
    u_g: "g",
    u_ml: "ml",
    u_cup: "cup",
    u_oz: "oz",
    u_tbsp: "tbsp",
    u_tsp: "tsp",
    u_plate: "plate",
    u_bowl: "bowl",
    u_can: "can",
    u_bottle: "bottle",
    u_spoon: "spoon",
    u_handful: "handful",
    u_glass: "glass",
    u_package: "package",
    u_box: "box",
    wizardNext: "Next",
    wizardSkip: "End Tour",
    wizardFinish: "Finish",
    helpTooltip: "Start Tour",
    clickToStop: "Click to stop",
    // Stats View
    statsTitle: "Nutrition Analytics",
    dietType: "Diet Profile",
    macroSplit: "Est. Macro Split",
    eatingHabits: "Eating Habits",
    avgMealsPerDay: "Avg Meals / Day",
    weeklyVariety: "7-Day Variety",
    uniqueIngredients: "Unique Ingredients",
    pieDisclaimer: "Calculated per unit, not weight. Indicative only.",
    avgBreakfastTime: "Avg Breakfast",
    avgLunchTime: "Avg Lunch",
    avgDinnerTime: "Avg Dinner",
    volumeChart: "Items Logged (Last 7 Days)",
    protein: "Protein",
    carbs: "Carbs",
    digestibleCarbs: "Digestible Carbs",
    fat: "Fat",
    fiber: "Fiber",
    analyzeDiet: "Analyze Diet",
    analyzingDiet: "Calculating...",
    calorieIntake: "Calorie Intake (Est.)",
    kcal: "kcal",
    // Favorites & Quick Add
    starredMeals: "Starred Meals",
    smartSuggestions: "Smart Suggestions",
    addFavorite: "Save as Favorite",
    editFavorite: "Edit Favorite",
    favoriteName: "Meal Name (e.g., Morning Oats)",
    usualTime: "Usual Time (Optional)",
    quickLog: "Quick Log",
    show: "Show",
    items: "items",
    doubleTapHint: "Double-tap a meal to Star/Unstar it",
    itemAlreadyExists: "is already recorded.",
    maxSuggestions: "Max Smart Suggestions",
    // Visual Settings
    visualDensity: "Visual Density",
    densityCompact: "Compact (Blade)",
    densityStandard: "Standard",
    densityComfort: "Comfort (Easy Access)",
    // Kitchen
    myKitchen: "My Kitchen",
    myPantry: "🥫 My Pantry",
    myCookbook: "📖 Cookbook",
    myFavorites: "⭐️ Favorites",
    pantryInfo: "Scan barcodes of processed foods you have at home. Name them (e.g., 'Home Muesli'). When you log 'Home Muesli' later, we'll use the exact ingredients from the barcode.",
    scanNewProduct: "Scan New Product",
    pantryEmpty: "Pantry is empty. Start scanning!",
    noCustomRecipes: "No custom recipes yet.",
    saveToPantry: "Save to Pantry",
    weFound: "We found:",
    nameThisItem: "Name this item",
    pantryPlaceholder: "e.g. My Muesli",
    createFromScratch: "Create from Scratch",
    adaptStandard: "Adapt Standard Dish",
    searchStandard: "Search standard dish...",
    recipeNamePlaceholder: "Recipe Name",
    homePrefix: "Home",
    ingredientsCount: "ingredients",
    inputCameraRecipe: "Scan Recipe Page",
    inputManualRecipe: "Manual Entry",
    servings: "Servings",
    homeRecipeLabel: "Home Recipe",
    cookbookLabel: "Cookbook",
    recipeLabel: "Recipe",
    // Health Records
    healthRecords: "Health Records",
    healthRecordsDesc: "Centralize your health data tools and connect external smart devices to VitalEat.",
    activeTools: "Active Tools",
    connectDevices: "Connect Devices",
    sportActivity: "Sport & Activity",
    logExercise: "Log exercise, duration, and calories",
    scaleMeasure: "Scale Measure",
    logWeight: "Log Weight, Body Fat & Hydration",
    smartWatch: "Smart Watch",
    smartScale: "Smart Scale",
    soon: "Soon",
    // Pantry Locations & Categories
    loc_pantry: "Pantry",
    loc_fridge: "Fridge",
    loc_freezer: "Freezer",
    loc_counter: "Counter",
    cat_canned: "Canned foods",
    cat_dry: "Dry goods",
    cat_snacks: "Snacks",
    cat_sauces: "Sauces",
    cat_jars: "Jars",
    cat_beverages: "Beverages",
    cat_bakery: "Bakery",
    cat_misc: "Misc",
    cat_dairy: "Dairy",
    cat_meats: "Meats",
    cat_fresh_meals: "Fresh meals",
    cat_spreads: "Spreads",
    cat_chilled_drinks: "Drinks",
    cat_desserts: "Desserts",
    cat_frozen_meals: "Plats surgelés",
    cat_frozen_produce: "Frozen produce",
    cat_frozen_meats: "Frozen meats",
    cat_ice_cream: "Ice cream",
    cat_frozen_snacks: "Frozen snacks",
    cat_on_the_go: "Snacks",
    cat_ambient_drinks: "Drinks",
    cat_fresh_bakery: "Bakery",
    // Donation / Water
    supportUs: "Support VitalEat",
    donateTitle: "Say Thank You",
    donateDesc: "VitalEat is free to use. If it helps you, consider buying me a coffee to keep the servers running!",
    monthlyCoffee: "€2 / Month (Coffee)",
    oneTimeDonation: "One-time Donation",
    donate5: "€5",
    donate20: "€20",
    donateMore: "Custom",
    logWater: "Log Water",
    waterLogged: "Water logged!",
    glassOfWater: "Glass of Water",
    hydration: "Hydration",
    dailyGoal: "Daily Goal",
    waterStreak: "Hydration Streak",
    addWater: "Add Water",
    customAmount: "Custom",
    todaysLogs: "Today's Logs",
    quickAddVolume: "Quick Add Volume (Double Tap)",
    waterSettings: "Water Settings",
    hydrationLevel: "Hydration Level",
    ml: "ml",
    hydrationMeasure: "Hydration Measure",
    addMeasure: "Add Measurement (%)",
    enterPercentage: "Enter Percentage",
    // User Profile
    userWeight: "User Weight",
    weightKg: "Weight (kg)",
    // Sport Information
    sportInfo: "Sport Activity",
    activityType: "Activity",
    startTime: "Start Time",
    duration: "Duration (min)",
    caloriesBurned: "Calories Burned",
    currentTemperature: "Local Temp",
    fetchingTemp: "Detecting...",
    noTemp: "Unknown",
    logActivity: "Log Activity",
    activitiesLogged: "Activities Logged",
    // Pharmacy
    pharmacy: "Virtual Pharmacy",
    medicationName: "Medication Name",
    dosage: "Dosage",
    stock: "Stock",
    expiryDate: "Expiration Date",
    shelfLife: "Shelf Life",
    adherence: "Adherence",
    addMedication: "Add Medication",
    takeDose: "Take Dose",
    medicationLogged: "Dose logged!",
    expired: "Expired",
    expiringSoon: "Expiring Soon",
    goodCondition: "Good",
    daysLeft: "days left",
    myCabinet: "My Cabinet",
    scanDrug: "Scan Drug",
    medsEmpty: "Cabinet is empty. Add your first medication.",
    // AI Analysis Tabs & Content
    trendsTitle: "Correlation Score (Level 1)",
    trendsSubtitle: "Based on time proximity",
    trendsSubtitleLowData: "Low Confidence - Insufficient Data",
    molecularMapping: "Molecular Mapping",
    molecularDesc: "Gemini has analyzed the chemical composition of your top 5 suspects to find common triggers.",
    geminiAnalysis: "Gemini 3.0 Analysis",
    clinicalSummary: "Clinical Summary",
    potentialProfile: "Potential Profile",
    recommendation: "Recommendation",
    analysisDisclaimer: "Disclaimer: AI analysis is for informational purposes only and does not constitute medical advice. Consult a professional.",
    analysisDisclaimerLowData: "CAUTION: Low historical data (<14 days). These results are based on partial data and may be inaccurate. Interpret with care.",
    analysisPending: "Analysis pending...",
    noClusters: "No clear chemical clusters found yet.",
    foundIn: "Found in",
    mealsLower: "meals",
    incidentsLower: "symptom incidents",
    whySuspect: "Why it's suspect:",
    suspectExplanation: "This ingredient appears frequently within the 12-hour window preceding your reported symptoms.",
    excludeAdvice: "Try excluding",
    excludeAdviceSuffix: "for 3 days to see if symptoms subside.",
    scoreNote: "Scores increase when symptoms follow a meal, and decrease when no symptoms occur.",
    risk: "Risk",
    lowDataWarning: "Low Data",
    // Tour Strings
    tour_home_streak_title: "Track Your Streak",
    tour_home_streak_desc: "This bar fills up as you log meals consistently. Try to hit 3 meals a day for 10 days!",
    tour_home_record_meal_title: "Log Food",
    tour_home_record_meal_desc: "Tap to log. Note: If you name a dish (e.g. 'Lasagna'), AI breaks it into ingredients and assumes a single portion (1/6th of standard recipe).",
    tour_home_record_symptom_title: "Log Feelings",
    tour_home_record_symptom_desc: "Not feeling well? Log headaches, bloating, or energy dips here to find patterns.",
    tour_home_analysis_title: "AI Analysis",
    tour_home_analysis_desc: "Once you have enough data, this card will reveal which ingredients might be causing your symptoms.",
    tour_nav_meals_title: "Meal Journal",
    tour_nav_meals_desc: "View your full history of what you've eaten here.",
    tour_nav_symptoms_title: "Symptom Journal",
    tour_nav_symptoms_desc: "Review your health history and severity trends here.",
    tour_weekly_calendar_title: "Weekly Overview",
    tour_weekly_calendar_desc: "Quickly see which days you've tracked. Active days are highlighted.",
    tour_meal_stats_title: "Daily Overview",
    tour_meal_stats_desc: "See how many items you've logged today. You can also quick-add a meal from here.",
    tour_symptom_stats_title: "Symptom Overview",
    tour_symptom_stats_desc: "Track the total number of side effects logged today.",
    tour_mic_button_title: "Voice Assistant",
    tour_mic_button_desc: "Tap to speak. Say 'I ate an apple' or 'I have a headache'. The button pulses when recording.",
    tour_session_type_title: "Meal Category",
    tour_session_type_desc: "Tap the icon to switch between Breakfast, Lunch, Dinner, or Snacks.",
    tour_session_time_title: "Edit Time",
    tour_session_time_desc: "Did you log this late? Tap here to adjust the timestamp.",
    tour_session_add_title: "Add Items",
    tour_session_add_desc: "Forgot something? Add more items to this specific meal entry.",
    tour_item_row_title: "Molecular Detail",
    tour_item_row_desc: "Tap any food item to reveal its breakdown: vitamins, minerals, and molecules.",
    tour_item_qty_title: "Adjust Quantity",
    tour_item_qty_desc: "Tap the number to refine the quantity or change the unit (e.g. grams to cups).",
    tour_item_delete_title: "Remove Item",
    tour_item_delete_desc: "Swipe or tap here to delete a single item from the list.",
    tour_symptom_severity_title: "Severity Score",
    tour_symptom_severity_desc: "Tap the colored badge to change the severity level (1-10).",
    // New Stats Tour
    tour_nav_stats_title: "Analytics Dashboard",
    tour_nav_stats_desc: "Deep dive into your nutrition stats, diet profile, and trends.",
    tour_stats_diet_title: "Dietary Profile",
    tour_stats_diet_desc: "AI analysis of your eating patterns, macro split, and key nutrients.",
    tour_stats_ranking_title: "Top Ingredients",
    tour_stats_ranking_desc: "See what you eat most frequently.",
    tour_stats_habits_title: "Eating Habits",
    tour_stats_habits_desc: "Track meal timing consistency and weekly variety.",
    tour_stats_volume_title: "Volume Trends",
    tour_stats_volume_desc: "See your logging consistency over the last 7 days.",
    // New Header Tour
    tour_header_kitchen_title: "My Kitchen",
    tour_header_kitchen_desc: "Manage your pantry, custom recipes, and favorite meals here.",
    tour_header_health_title: "Health Hub",
    tour_header_health_desc: "Track weight, activities, and connect smart devices.",
    tour_header_pharmacy_title: "Pharmacy",
    tour_header_pharmacy_desc: "Manage medication stock and log intake.",
    tour_smart_suggestions_title: "Smart Suggestions",
    tour_smart_suggestions_desc: "Quick-add your most frequent or predicted meals.",
    tour_calendar_toggle_title: "Calendar View",
    tour_calendar_toggle_desc: "Toggle between weekly and monthly history views.",
    notInDatabase: "not found in database.",
    rejectedSymptoms: "Rejected (not in DB)",
    rejectedFoods: "Rejected (not in DB)",
  },
  fr: {
    welcome: "Bon retour,",
    hello: "Bonjour !",
    streakTitle: "Série de Constance",
    streakSubtitle: "(3+ repas/jour sur 10 jours)",
    day: "Jour",
    recordMeal: "Enregistrer Repas",
    recordSymptom: "Effets Secondaires",
    swipeHint: "Glisser à gauche pour voir l'historique",
    mealJournal: "Journal Alimentaire",
    symptomJournal: "Journal des Symptômes",
    itemsLogged: "Aliments Aujourd'hui",
    noMeals: "Aucun repas enregistré.",
    noSymptoms: "Aucun symptôme enregistré.",
    listeningItems: "Écoute des aliments...",
    listeningSymptoms: "Description de l'état...",
    itemsLoggedCount: "aliments notés",
    symptomsLoggedCount: "symptômes notés",
    time: "Heure",
    item: "Aliment",
    qty: "Qté",
    symptom: "Symptôme",
    intensity: "Intensité",
    molecularComp: "Composition Moléculaire",
    analyzing: "Analyse de la structure chimique...",
    noData: "Pas de données disponibles.",
    recordingMeal: "Enregistrement Repas",
    recordingSymptoms: "Enregistrement Symptômes",
    offline: "Hors ligne",
    home: "Accueil",
    meal: "Repas",
    meals: "Repas",
    symptoms: "Symptômes",
    stats: "Stats",
    settings: "Paramètres",
    preferences: "Préférences",
    language: "Langue",
    darkMode: "Mode Sombre",
    notifications: "Notifications",
    enableNotifications: "Activer Notifications",
    reminders: "Rappels Quotidiens",
    account: "Compte",
    dataManagement: "Gestion des Données",
    exportData: "Exporter les Données (JSON)",
    importData: "Importer les Données (JSON)",
    importSuccess: "Données importées avec succès !",
    importError: "Échec de l'importation. Vérifiez le format.",
    sendFeedback: "Envoyer un Avis",
    shareApp: "Partager l'App",
    logout: "Déconnexion",
    login: "Connexion",
    signup: "S'inscrire",
    email: "Email",
    password: "Mot de passe",
    breakfast: "Petit-déjeuner",
    lunch: "Déjeuner",
    dinner: "Dîner",
    snack: "Collation",
    afternoonSnack: "Goûter",
    addMealTooltip: "Ajouter un repas",
    addSymptomTooltip: "Ajouter un symptôme",
    deleteItem: "Supprimer l'élément",
    deleteItemConfirm: "Êtes-vous sûr de vouloir supprimer cet enregistrement ?",
    deleteSymptom: "Supprimer le symptôme",
    addItemToMeal: "Ajouter des éléments",
    deleteSessionConfirm: "Êtes-vous sûr de vouloir supprimer toute cette entrée ? Cette action est irréversible.",
    deleteSessionTooltip: "Supprimer l'entrée entière",
    noAccount: "Pas encore de compte ?",
    haveAccount: "Déjà un compte ?",
    verifyEmail: "Vérifier l'Email",
    enterCode: "Entrez le Code de Vérification",
    codeSentTo: "Nous avons envoyé un code à",
    verify: "Vérifier",
    resendCode: "Renvoyer le Code",
    invalidCode: "Code invalide. Essayez '1234'.",
    codeSentAlert: "Votre code de vérification est : 1234",
    today: "Aujourd'hui",
    yesterday: "Hier",
    aiInsights: "Analyses Santé IA",
    aiInsightsPreliminary: "Analyse Préliminaire",
    aiInsightsLocked: "Analyses IA (Verrouillé)",
    learningPhase: "Phase d'Apprentissage",
    dataPoints: "Points de Données",
    daysTracked: "Jours Suivis",
    analysisComplete: "Analyse Prête",
    highRisk: "Probabilité Élevée",
    mediumRisk: "Probabilité Moyenne",
    lowRisk: "Probabilité Faible",
    potentialIrritant: "Irritant Potentiel",
    generateAnalysis: "Mettre à jour l'analyse",
    startAnalysis: "Révéler les Corrélations",
    locked: "Verrouillé",
    readyToAnalyze: "Nous avons assez de données pour identifier les déclencheurs.",
    readyToAnalyzeLowData: "Vérification préliminaire disponible.",
    analyzingPatterns: "Détection des modèles moléculaires...",
    notEnoughData: "Continuez à noter vos repas et symptômes pour débloquer l'IA.",
    notEnoughDataLowData: "Données historiques faibles (<14 jours). L'IA peut effectuer une vérification approximative, mais la précision sera moindre.",
    lockedMessage: "Enregistrez au moins 10 jours d'historique pour débloquer l'analyse IA.",
    unlockProgress: "{{current}} / 10 Jours d'Historique",
    recordedSuccessfully: "Enregistrement réussi !",
    editSession: "Modifier l'Heure",
    update: "Mettre à jour",
    cancel: "Annuler",
    selectTime: "Sélectionner Date & Heure",
    changeSeverity: "Ajuster l'Intensité",
    editQuantity: "Modifier Quantité",
    save: "Sauvegarder",
    customUnit: "Unité perso",
    quickSelect: "Sélection Rapide",
    manualEntry: "Saisie Manuelle",
    enterFoodName: "Nom de l'aliment (ex: Pomme)",
    enterSymptomName: "Symptôme (ex: Mal de tête)",
    addManually: "Ajouter Manuellement",
    processing: "Traitement...",
    changeMealType: "Changer le Type de Repas",
    chooseInputMethod: "Choisir Méthode",
    inputAudio: "Enregistrement Vocal",
    inputCameraRecipe: "Prendre une Recette",
    inputManualRecipe: "Saisie Manuelle",
    inputText: "Saisie Texte",
    inputBarcode: "Scanner Code-barres",
    inputCamera: "Prendre Photo",
    comingSoon: "Bientôt",
    scale0: "Aucun symptôme",
    scale1_2: "Très léger — à peine perceptible",
    scale3_4: "Léger — perceptible mais ne gêne pas",
    scale5_6: "Modéré — gêne un peu les activités",
    scale7_8: "Sévère — limite beaucoup l'activité",
    scale9: "Très sévère — presque incapacitant",
    scale10: "Extrême — insupportable",
    u_piece: "pièce",
    u_slice: "tranche",
    u_serving: "portion",
    u_g: "g",
    u_ml: "ml",
    u_cup: "tasse",
    u_oz: "once",
    u_tbsp: "c.à.s",
    u_tsp: "c.à.c",
    u_plate: "assiette",
    u_bowl: "bol",
    u_can: "canette",
    u_bottle: "bouteille",
    u_spoon: "cuillère",
    u_handful: "poignée",
    u_glass: "verre",
    u_package: "paquet",
    u_box: "boîte",
    wizardNext: "Suivant",
    wizardSkip: "Quitter",
    wizardFinish: "Terminer",
    helpTooltip: "Lancer la visite",
    clickToStop: "Cliquer pour arrêter",
    // Stats View
    statsTitle: "Analyses Nutrition",
    dietType: "Profil Alimentaire",
    macroSplit: "Répartition Macros (Est.)",
    eatingHabits: "Habitudes Alimentaires",
    avgMealsPerDay: "Moy. Repas / Jour",
    weeklyVariety: "Variété Hebdo",
    uniqueIngredients: "Ingrédients Uniques",
    pieDisclaimer: "Calculé par unité, pas par poids. Indicatif seulement.",
    avgBreakfastTime: "Moy. Petit-déj",
    avgLunchTime: "Moy. Déjeuner",
    avgDinnerTime: "Moy. Dîner",
    volumeChart: "Aliments Notés (7 derniers jours)",
    protein: "Protéines",
    carbs: "Glucides",
    digestibleCarbs: "Glucides dig.",
    fat: "Lipides",
    fiber: "Fibres",
    analyzeDiet: "Analyser Régime",
    analyzingDiet: "Calcul en cours...",
    calorieIntake: "Apport Calorique (Est.)",
    kcal: "kcal",
    // Favorites & Quick Add
    starredMeals: "Repas Favoris",
    smartSuggestions: "Suggestions Intelligentes",
    addFavorite: "Sauvegarder en Favori",
    editFavorite: "Modifier le Favori",
    favoriteName: "Nom du Repas (ex: Muesli Matin)",
    usualTime: "Heure Habituelle (Optionnel)",
    quickLog: "Ajout Rapide",
    show: "Voir",
    items: "aliments",
    doubleTapHint: "Double-tapez un repas pour le mettre en Favori",
    itemAlreadyExists: "est déjà enregistré.",
    maxSuggestions: "Max Suggestions Intelligentes",
    // Visual Settings
    visualDensity: "Densité Visuelle",
    densityCompact: "Compact (Lame)",
    densityStandard: "Standard",
    densityComfort: "Confort (Accès Facile)",
    // Kitchen
    myKitchen: "Ma Cuisine",
    myPantry: "🥫 Mon Garde-manger",
    myCookbook: "📖 Carnet de Recettes",
    myFavorites: "⭐️ Favoris",
    pantryInfo: "Scannez les codes-barres de vos produits. Nommez-les (ex: 'Muesli Maison'). Quand vous noterez 'Muesli Maison', les ingrédients exacts seront utilisés.",
    scanNewProduct: "Scanner un Produit",
    pantryEmpty: "Garde-manger vide. Scannez !",
    noCustomRecipes: "Pas encore de recettes personnalisées.",
    saveToPantry: "Enregistrer",
    weFound: "Trouvé :",
    nameThisItem: "Nommez cet article",
    pantryPlaceholder: "ex: Mon Muesli",
    createFromScratch: "Créer de zéro",
    adaptStandard: "Adapter un Plat Standard",
    searchStandard: "Chercher plat standard...",
    recipeNamePlaceholder: "Nom de la recette",
    homePrefix: "Maison",
    ingredientsCount: "ingrédients",
    servings: "Personnes",
    homeRecipeLabel: "Recette Maison",
    cookbookLabel: "Livre de Recettes",
    recipeLabel: "Recette",
    // Health Records
    healthRecords: "Dossier Santé",
    healthRecordsDesc: "Centralisez vos données de santé et connectez vos appareils.",
    activeTools: "Outils Actifs",
    connectDevices: "Connecter Appareils",
    sportActivity: "Sport & Activité",
    logExercise: "Exercice, durée et calories",
    scaleMeasure: "Mesure Balance",
    logWeight: "Poids, Graisse & Hydratation",
    smartWatch: "Montre Connectée",
    smartScale: "Balance Connectée",
    soon: "Bientôt",
    // Pantry Locations & Categories
    loc_pantry: "Garde-manger",
    loc_fridge: "Frigo",
    loc_freezer: "Congélateur",
    loc_counter: "Comptoir",
    cat_canned: "Conserves",
    cat_dry: "Produits secs",
    cat_snacks: "Snacks",
    cat_sauces: "Sauces",
    cat_jars: "Bocaux",
    cat_beverages: "Boissons",
    cat_bakery: "Boulangerie",
    cat_misc: "Divers",
    cat_dairy: "Produits laitiers",
    cat_meats: "Viandes",
    cat_fresh_meals: "Plats frais",
    cat_spreads: "Tartinables",
    cat_chilled_drinks: "Boissons fraîches",
    cat_desserts: "Desserts",
    cat_frozen_meals: "Plats surgelés",
    cat_frozen_produce: "Légumes/Fruits",
    cat_frozen_meats: "Viandes surgelées",
    cat_ice_cream: "Glaces",
    cat_frozen_snacks: "Snacks surgelés",
    cat_on_the_go: "À emporter",
    cat_ambient_drinks: "Boissons",
    cat_fresh_bakery: "Boulangerie",
    // Donation / Water
    supportUs: "Soutenir VitalEat",
    donateTitle: "Dire Merci",
    donateDesc: "VitalEat est gratuit. Si cela vous aide, offrez-moi un café pour soutenir les serveurs !",
    monthlyCoffee: "2€ / Mois (Café)",
    oneTimeDonation: "Don Ponctuel",
    donate5: "5€",
    donate20: "20€",
    donateMore: "Autre",
    logWater: "Noter Eau",
    waterLogged: "Eau notée !",
    glassOfWater: "Verre d'eau",
    hydration: "Hydratation",
    dailyGoal: "Objectif Quotidien",
    waterStreak: "Série d'Hydratation",
    addWater: "Ajouter Eau",
    customAmount: "Autre",
    todaysLogs: "Historique du Jour",
    quickAddVolume: "Volume Ajout Rapide (Double Tape)",
    waterSettings: "Paramètres Eau",
    hydrationLevel: "Niveau d'Hydratation",
    ml: "ml",
    hydrationMeasure: "Mesure Hydratation",
    addMeasure: "Ajouter Mesure (%)",
    enterPercentage: "Entrer Pourcentage",
    // User Profile
    userWeight: "Poids de l'utilisateur",
    weightKg: "Poids (kg)",
    // Sport Information
    sportInfo: "Activité Sportive",
    activityType: "Activité",
    startTime: "Heure de début",
    duration: "Durée (min)",
    caloriesBurned: "Calories Brûlées",
    currentTemperature: "Température Locale",
    fetchingTemp: "Détection...",
    noTemp: "Inconnue",
    logActivity: "Enregistrer Activité",
    activitiesLogged: "Activités Enregistrées",
    // Pharmacy
    pharmacy: "Pharmacie Virtuelle",
    medicationName: "Nom du Médicament",
    dosage: "Dosage",
    stock: "Stock",
    expiryDate: "Date d'Expiration",
    shelfLife: "Durée de Vie",
    adherence: "Observance",
    addMedication: "Ajouter Médicament",
    takeDose: "Prendre Dose",
    medicationLogged: "Dose notée !",
    expired: "Expiré",
    expiringSoon: "Expire Bientôt",
    goodCondition: "Bon",
    daysLeft: "jours restants",
    myCabinet: "Mon Armoire",
    scanDrug: "Scanner Médicament",
    medsEmpty: "Armoire vide. Ajoutez votre premier médicament.",
    // AI Analysis Tabs & Content
    trendsTitle: "Score de Corrélation (Niveau 1)",
    trendsSubtitle: "Basé sur la proximité temporelle",
    trendsSubtitleLowData: "Faible Confiance - Données Insuffisantes",
    molecularMapping: "Cartographie Moléculaire",
    molecularDesc: "Gemini a analysé la composition chimique de vos 5 principaux suspects pour trouver des déclencheurs communs.",
    geminiAnalysis: "Analyse Gemini 3.0",
    clinicalSummary: "Résumé Clinique",
    potentialProfile: "Profil Potentiel",
    recommendation: "Recommandation",
    analysisDisclaimer: "Avertissement : L'analyse IA est à titre informatif uniquement et ne constitue pas un avis médical. Consultez un professionnel.",
    analysisDisclaimerLowData: "ATTENTION : Données historiques faibles (<14 jours). Ces résultats sont basés sur des données partielles et peuvent être inexacts. À prendre avec des pincettes.",
    analysisPending: "Analyse en cours...",
    noClusters: "Aucun cluster chimique évident trouvé pour le moment.",
    foundIn: "Trouvé dans",
    mealsLower: "repas",
    incidentsLower: "incidents",
    whySuspect: "Pourquoi c'est suspect :",
    suspectExplanation: "Cet ingrédient apparaît fréquemment dans la fenêtre de 12 heures précédant vos symptômes signalés.",
    excludeAdvice: "Essayez d'exclure",
    excludeAdviceSuffix: "pendant 3 jours pour voir si les symptômes diminuent.",
    scoreNote: "Les scores augmentent quand des symptômes suivent un repas, et diminuent si aucun symptôme ne survient.",
    risk: "Risque",
    lowDataWarning: "Peu de Données",
    // Tour Strings
    tour_home_streak_title: "Suivez votre Série",
    tour_home_streak_desc: "Cette barre se remplit si vous êtes régulier. Visez 3 repas par jour sur 10 jours !",
    tour_home_record_meal_title: "Noter un Repas",
    tour_home_record_meal_desc: "Appuyez pour noter. Note : Si vous nommez un plat (ex: 'Lasagnes'), l'IA le décompose en ingrédients pour une portion (1/6ème de la recette).",
    tour_home_record_symptom_title: "Noter un Symptôme",
    tour_home_record_symptom_desc: "Mal de tête ? Ballonnement ? Notez-le ici pour trouver des liens.",
    tour_home_analysis_title: "Analyse IA",
    tour_home_analysis_desc: "Avec assez de données, cette carte révélera les ingrédients qui causent vos symptômes.",
    tour_nav_meals_title: "Journal des Repas",
    tour_nav_meals_desc: "Retrouvez ici tout l'historique de ce que vous avez mangé.",
    tour_nav_symptoms_title: "Journal des Symptômes",
    tour_nav_symptoms_desc: "Consultez ici l'historique de votre santé et l'évolution des symptômes.",
    tour_weekly_calendar_title: "Aperçu Hebdomadaire",
    tour_weekly_calendar_desc: "Voyez rapidement quels jours sont suivis. Les jours actifs sont mis en évidence.",
    tour_meal_stats_title: "Aperçu Quotidien",
    tour_meal_stats_desc: "Voyez combien d'aliments sont notés aujourd'hui. Ajoutez-en rapidement d'ici.",
    tour_symptom_stats_title: "Aperçu Symptômes",
    tour_symptom_stats_desc: "Suivez le nombre total d'effets secondaires notés aujourd'hui.",
    tour_mic_button_title: "Assistant Vocal",
    tour_mic_button_desc: "Appuyez pour parler. Dites 'J'ai mangé une pomme' ou 'J'ai mal à la tête'. Le bouton pulse pendant l'enregistrement.",
    tour_session_type_title: "Catégorie de Repas",
    tour_session_type_desc: "Appuyez sur l'icône pour changer (Petit-déj, Déjeuner, Dîner...).",
    tour_session_time_title: "Modifier l'Heure",
    tour_session_time_desc: "Vous avez noté plus tard ? Appuyez ici pour ajuster l'horodatage.",
    tour_session_add_title: "Ajouter des Éléments",
    tour_session_add_desc: "Oublié quelque chose ? Ajoutez des aliments à ce repas spécifique.",
    tour_item_row_title: "Détail Moléculaire",
    tour_item_row_desc: "Appuyez sur un aliment pour voir sa composition chimique détaillée.",
    tour_item_qty_title: "Ajuster Quantité",
    tour_item_qty_desc: "Appuyez sur le nombre pour affiner la quantité ou changer l'unité.",
    tour_item_delete_title: "Supprimer Élément",
    tour_item_delete_desc: "Appuyez ici pour supprimer un seul élément de la liste.",
    tour_symptom_severity_title: "Score de Sévérité",
    tour_symptom_severity_desc: "Appuyez sur le badge coloré pour changer le niveau (1-10).",
    // New Stats Tour FR
    tour_nav_stats_title: "Tableau de Bord",
    tour_nav_stats_desc: "Plongez dans vos stats nutritionnelles, profil alimentaire et tendances.",
    tour_stats_diet_title: "Profil Alimentaire",
    tour_stats_diet_desc: "Analyse IA de vos habitudes, répartition macro et nutriments clés.",
    tour_stats_ranking_title: "Top Ingrédients",
    tour_stats_ranking_desc: "Découvrez ce que vous mangez le plus souvent.",
    tour_stats_habits_title: "Habitudes",
    tour_stats_habits_desc: "Suivez la régularité de vos repas et la variété hebdomadaire.",
    tour_stats_volume_title: "Variété Hebdo",
    tour_stats_volume_desc: "Visualisez votre régularité de saisie sur les 7 derniers jours.",
    // New Header Tour FR
    tour_header_kitchen_title: "Ma Cuisine",
    tour_header_kitchen_desc: "Gérez votre garde-manger, recettes personnalisées et plats favoris ici.",
    tour_header_health_title: "Pôle Santé",
    tour_header_health_desc: "Suivez votre poids, vos activités et connectez vos appareils intelligents.",
    tour_header_pharmacy_title: "Pharmacie",
    tour_header_pharmacy_desc: "Gérez votre stock de médicaments et enregistrez les prises.",
    tour_smart_suggestions_title: "Suggestions Intelligentes",
    tour_smart_suggestions_desc: "Ajoutez rapidement vos repas les plus fréquents ou prédits.",
    tour_calendar_toggle_title: "Vue Calendrier",
    tour_calendar_toggle_desc: "Basculez entre les vues hebdomadaire et mensuelle.",
    notInDatabase: "pas trouvé dans la base.",
    rejectedSymptoms: "Rejeté (pas en base)",
    rejectedFoods: "Rejeté (pas en base)",
  }
};

export type TranslationKey = keyof typeof translations.en;

export const t = (lang: Language, key: TranslationKey, params?: Record<string, string | number>): string => {
  let text = translations[lang][key] || translations['en'][key];
  if (params) {
      Object.entries(params).forEach(([k, v]) => {
          text = text.replace(`{{${k}}}`, String(v));
      });
  }
  return text;
};
